import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { groupBy, isNil, map } from 'lodash';
import { graphDataSelector } from 'modules/campaigns/selectors';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';

const metricRenameHackMap = {
    vctr: 'CTR',
    vcpm: 'CPM',
    visibleImpressions: 'Impressions',
    impressions: 'Served Ads',
};

export const useSingleMetricGraph = graphConfig => {
    const isAlignDefinitions = useConfigMatch({ [FEATURE_FLAGS.ALIGN_IMPRESSIONS_DEFINITIONS_ENABLED]: 'true' });

    const legendDropdownMetrics = useMemo(() => {
        if (!isAlignDefinitions) {
            return graphConfig.metrics.map(metric => ({
                value: metric.label,
                label: metric.label,
                field: metric.field,
            }));
        }

        // todo: remove this hack DEV-183569
        return graphConfig.metrics
            .filter(metric => metric.field !== 'ctr' && metric.field !== 'cpm') // Remove old CTR & CPM
            .map(metric => ({
                value: metric.label,
                label: metricRenameHackMap[metric.field] || metric.label,
                field: metric.field,
            }));
    }, [graphConfig.metrics, isAlignDefinitions]);

    const [selectedLegendDropdownMetric, setSelectedLegendDropdownMetric] = useState(legendDropdownMetrics[0]);
    const graphDataRaw = useSelector(graphDataSelector);

    const graphData = useMemo(() => {
        const {
            graphProps: { xAxisDataKey },
            collatingKey,
        } = graphConfig;
        const { field: selectedMetric } = selectedLegendDropdownMetric;
        const valuesGroupedByXAxisDataKey = groupBy(graphDataRaw, xAxisDataKey);

        const transposedGraphData = map(valuesGroupedByXAxisDataKey, (values, xAxisDataKeyValue) => {
            const dataPoint = {
                [xAxisDataKey]: parseInt(xAxisDataKeyValue) || xAxisDataKeyValue,
            };
            values.forEach(valueObj => {
                if (isNil(valueObj[collatingKey])) {
                    return;
                }
                const collatingKeyValue = valueObj[collatingKey];
                dataPoint[collatingKeyValue] = valueObj[selectedMetric];
            });

            return dataPoint;
        });

        return transposedGraphData;
    }, [graphConfig, graphDataRaw, selectedLegendDropdownMetric]);

    return {
        selectedLegendDropdownMetric,
        legendDropdownMetrics,
        onMetricDropdownChange: setSelectedLegendDropdownMetric,
        graphData,
    };
};
